"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeOrderClient = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const __1 = require("../");
const types_1 = require("../types");
class TradeOrderClient {
    constructor(ctx, publicKey, data, pda, configid) {
        this.ctx = ctx;
        this.data = data;
        this.publicKey = publicKey;
        this.pda = pda;
        this.configId = configid;
    }
    static getOrder(ctx, configId, orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId);
            const tradeOrderPublickey = pda.getTradeOrderPDA(orderId).key;
            const tradeOrderAccount = (yield ctx.program.account.tradeOrder.fetch(tradeOrderPublickey));
            if (!tradeOrderAccount) {
                throw new Error(`Trade order ${orderId} not found`);
            }
            return new TradeOrderClient(ctx, tradeOrderPublickey, tradeOrderAccount, pda, configId);
        });
    }
    static makeSellOrder(ctx, configId, seller, tokenMint, bondType, tokenAmount, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId);
            const configAddress = pda.getConfigPDA().key;
            let configAccount = (yield ctx.program.account.escrowConfig.fetch(configAddress));
            if (!configAccount) {
                throw new Error(`Escrow config ${configAddress} not found`);
            }
            const tradeOrderPDA = pda.getTradeOrderPDA(configAccount.currentId);
            const tokenVaultPDA = pda.getTokenVaultPDA(configAccount.currentId);
            const nativeVaultPDA = pda.getNativeVaultPDA(configAccount.currentId);
            const sellerTokenAccount = yield (0, common_sdk_1.deriveATA)(seller, tokenMint);
            const tokenInfoPDA = pda.getTokenInfoPDA(tokenMint);
            const tx = (yield ctx.ixs.makeOrderIx({
                escrowConfig: configAddress,
                side: types_1.OrderSide.Sell,
                bondType: bondType,
                tradeOrderPDA,
                tokenMint,
                tokenInfo: tokenInfoPDA.key,
                userTokenAccount: sellerTokenAccount,
                tokenVaultPDA,
                nativeVaultPDA,
                user: seller,
                tokenAmount: tokenAmount,
                fiatAmount: fiatAmount,
            })).toTx();
            return { tx, id: configAccount.currentId };
        });
    }
    static makeBuyOrder(ctx, configId, buyer, tokenMint, tokenAmount, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId);
            const configAddress = pda.getConfigPDA().key;
            let configAccount = (yield ctx.program.account.escrowConfig.fetch(configAddress));
            if (!configAccount) {
                throw new Error(`Escrow config ${configAddress} not found`);
            }
            const tradeOrderPDA = pda.getTradeOrderPDA(configAccount.currentId);
            const tokenVaultPDA = pda.getTokenVaultPDA(configAccount.currentId);
            const nativeVaultPDA = pda.getNativeVaultPDA(configAccount.currentId);
            const buyerTokenAccount = yield (0, common_sdk_1.deriveATA)(buyer, tokenMint);
            const tokenInfoPDA = pda.getTokenInfoPDA(tokenMint);
            const tx = (yield ctx.ixs.makeOrderIx({
                escrowConfig: configAddress,
                side: types_1.OrderSide.Buy,
                bondType: types_1.BondType.Spl,
                tradeOrderPDA: tradeOrderPDA,
                tokenMint,
                tokenInfo: tokenInfoPDA.key,
                userTokenAccount: buyerTokenAccount,
                tokenVaultPDA,
                nativeVaultPDA,
                user: buyer,
                tokenAmount: tokenAmount,
                fiatAmount: fiatAmount,
            })).toTx();
            return { tx, id: configAccount.currentId };
        });
    }
    cancelOrder(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint, tokenVault, nativeVault } = this.data;
            // Get or create canceller token account
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, user, tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, user), { address: userTokenAccount } = _a, instruction = __rest(_a, ["address"]);
            const tx = (yield this.ctx.ixs.cancelOrderIx({
                tradeOrder: this.publicKey,
                user: user,
                userTokenAccount: userTokenAccount,
                tokenVault,
                nativeVault,
            }))
                .toTx()
                .prependInstruction(instruction);
            return tx;
        });
    }
    joinOrder(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint, tokenVault, nativeVault } = this.data;
            let prependIxs = [];
            // get config client
            const pda = new __1.PDA(this.ctx.program.programId, this.configId);
            // Get or create joinner token account
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, user, tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, user), { address: userTokenAccount } = _a, instruction = __rest(_a, ["address"]);
            prependIxs.push(instruction);
            // Get or create default joinner kyc cert
            const userKycCertPda = pda.getKycCertPDA(user);
            const accountInfo = yield this.ctx.connection.getAccountInfo(userKycCertPda.key);
            const escrowConfig = pda.getConfigPDA().key;
            if (accountInfo == null) {
                const initKycCertIx = (yield this.ctx.ixs.initKycCertIx({
                    escrowConfig,
                    caller: user,
                    user,
                    kycCertPubkey: userKycCertPda.key,
                    kycCertBump: userKycCertPda.bump,
                })).ix;
                if (!initKycCertIx) {
                    throw new Error("Fail to get the initialize kyc cert instruction");
                }
                prependIxs.push(initKycCertIx);
            }
            const tx = (yield this.ctx.ixs.joinSellOrderIx({
                escrowConfig,
                tradeOrder: this.publicKey,
                user,
                userKycCert: userKycCertPda.key,
                userTokenAccount,
                tokenVault,
                nativeVault,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return tx;
        });
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            const { sellerAuthority, buyerAuthority, tokenVault, nativeVault } = this.data;
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, sellerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, sellerAuthority), { address: sellerTokenAccount } = _a, createSellerTokenAccountInstruction = __rest(_a, ["address"]);
            const _b = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, buyerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, sellerAuthority), { address: buyerTokenAccount } = _b, createBuyerTokenAccountInstruction = __rest(_b, ["address"]);
            const tx = (yield this.ctx.ixs.releaseIx({
                tradeOrder: this.publicKey,
                seller: sellerAuthority,
                buyer: buyerAuthority,
                sellerTokenAccount,
                buyerTokenAccount,
                tokenVault,
                nativeVault,
            }))
                .toTx()
                .prependInstructions([
                createSellerTokenAccountInstruction,
                createBuyerTokenAccountInstruction,
            ]);
            return tx;
        });
    }
    callArbitrator(caller) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.callArbitrator({
                escrowConfig: this.data.escrowConfig,
                tradeOrder: this.publicKey,
                caller: caller,
            })).toTx();
            return tx;
        });
    }
    resolveDispute(arbitrator, disputeAction, compensationAction) {
        return __awaiter(this, void 0, void 0, function* () {
            // Get or create corressponding token accounts of parties if needed
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, arbitrator, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: arbitratorTokenAccount } = _a, createArbitratorTokenAccountInstruction = __rest(_a, ["address"]);
            const _b = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, this.data.sellerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: sellerTokenAccount } = _b, createSellerTokenAccountInstruction = __rest(_b, ["address"]);
            const _c = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, this.data.buyerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: buyerTokenAccount } = _c, createBuyerTokenAccountInstruction = __rest(_c, ["address"]);
            const escrowConfig = (yield this.ctx.program.account.escrowConfig.fetch(this.data.escrowConfig));
            const _d = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, escrowConfig.treasuryPubkey, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: treasuryTokenAccount } = _d, createTreasuryTokenAccountInstruction = __rest(_d, ["address"]);
            const tx = (yield this.ctx.ixs.resolveDispute({
                disputeAction,
                compensationAction,
                escrowConfig: this.data.escrowConfig,
                tradeOrder: this.publicKey,
                treasuryAuthority: escrowConfig.treasuryPubkey,
                arbitratorAuthority: arbitrator,
                treasuryTokenAccount: treasuryTokenAccount,
                arbitartorCert: this.pda.getArbitratorCertPDA(arbitrator).key,
                arbitratorTokenAccount: arbitratorTokenAccount,
                seller: this.data.sellerAuthority,
                sellerTokenAccount: sellerTokenAccount,
                buyer: this.data.buyerAuthority,
                buyerTokenAccount: buyerTokenAccount,
                tokenVault: this.data.tokenVault,
                nativeVault: this.data.nativeVault,
            }))
                .toTx()
                .prependInstructions([
                createArbitratorTokenAccountInstruction,
                createBuyerTokenAccountInstruction,
                createSellerTokenAccountInstruction,
                createTreasuryTokenAccountInstruction,
            ]);
            return tx;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const tradeOrderAccount = (yield this.ctx.program.account.tradeOrder.fetch(this.publicKey));
            this.data = tradeOrderAccount;
            return this;
        });
    }
}
exports.TradeOrderClient = TradeOrderClient;
